<template>
    <div class="industry-picker">

        <!-- Button -->
        <div>
            <button v-if="type == 'primary'"
                    type="button"
                    class="btn btn-primary"
                    @click="showSelector"
            >{{ label }}</button>
            <button v-if="type == 'default'"
                    type="button"
                    class="btn btn-default"
                    @click="showSelector"
            >{{ label }}</button>
            <button  v-if="type == 'text'"
                     type="button"
                     class="text"
                     @click="showSelector"
            >{{ label }}</button>
            <button  v-if="type == 'icon'"
                     type="button"
                     class="btn text"
                     @click="showSelector"
            ><span class="fa fa-exchange"></span> {{ label }}</button>
        </div>

        <!-- Modal -->
        <div ref="picker"
             class="modal fade industry-picker-modal"
             role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">

                <div class="modal-content">
                    <div class="modal-header">
                        <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
                        <h4 class="modal-title">Select Industry</h4>
                    </div>
                    <div class="modal-body">

                        <div v-if="industries.length > 0" >
                            <div class="user-account-container inner-padding-sm scroll add-pointer p-l-20" :value="0"
                                @click="selectIndustry({ industry_id: 0, industry_nm: 'All Industries' })"
                                v-if="include_all_industries"
                            >
                                <div class="text-bold text-uppercase">
                                    All Industries
                                </div>
                            </div>
                            <div v-for="industry in industries" class="user-account-container inner-padding-sm scroll add-pointer p-l-20"  :value="industry.industry_id"  @click="selectIndustry(industry)">
                                <div class="text-bold text-uppercase">
                                    {{ industry.industry_nm}}
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-lg btn-secondary" data-dismiss="modal"><span class="fa fa-times"></span> &nbsp;Close</button>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<style lang="scss">

    @import '../../sass/_global_variables.scss';

    .industry-picker {
        display: inline-block;
        .text {
            background: transparent;
            color: $med-blue;
            cursor: pointer;
            border: none;
            padding: 0px;
            &:hover {
                color: $med-blue-hover;
            }
        }
    }


</style>

<script>
    export default {
        props: {
            type: { default: 'primary' },
            label: { default: 'Select Industry' },
            include_all_industries: { default: false }
        },

        data () {
            return {
                industries: [],
                picker: null
            }
        },

        methods: {
            showSelector () {
                this.getIndustries();
                this.picker.modal('show');
            },

            selectIndustry (industry) {
                // Figure out getting the proper industry here
                var request = this.$http.post('/change-industry', { industry_id: industry.industry_id });
                request.then(function (response) {
                    var industry = response.body;
                    this.$emit('select', industry);
                    this.picker.modal('hide');
                });
            },

            getIndustries () {
               this.$http.get('/industries', {})
                .then((response) => {
                    if (response.data) {
                        this.industries  = response.data;
                    }
                });
            }
        },

        mounted () {
            this.picker = $(this.$refs.picker);
            $('body').append(this.picker);
        }
    }
</script>



// WEBPACK FOOTER //
// industry-picker.vue?3801b7f2